export default {
  en: {
    'pages.troubleshoot-page.action-paragraph.instructions':
      'To resolve issues you are required to download the data, correct it and then re-upload it.',
    'pages.troubleshoot-page.action-buttons.download-data': 'Download Data',
    'pages.troubleshoot-page.action-buttons.ignore-data': 'Ignore All Warnings',
    'pages.troubleshoot-page.action-buttons.overwrite-data': 'Overwrite Data',
    'pages.troubleshoot-page.troubleshoot-title': 'Troubleshoot Issues',
    'pages.troubleshoot-page.error-title': 'Errors',
    'pages.troubleshoot-page.warning-title': 'Warnings',
    'pages.troubleshoot-page.no-results.title': 'No Issues Found',
    'pages.troubleshoot-page.no-results.description': 'All errors and warnings are resolved.',
  },
};
